import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { TaskQueues, QueuePriorityArrayValues } from '../../helpers/schema';

export const schema = z
  .object({
    sessionId: z.string().min(1),
    title: z.string().min(1),
    description: z.string().optional(),
    priority: z.enum(QueuePriorityArrayValues).optional(),
    assignedTo: z.number().optional(),
    assignedPersonaId: z.string().optional(), // AI persona assignment
    fileId: z.string().optional(),
  })
  .refine((data) => !(data.assignedTo && data.assignedPersonaId), {
    message: 'Cannot assign to both a user and an AI persona',
  });

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  task: Selectable<TaskQueues>;
};

export const createTask = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/tasks/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
